import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { LocationComponent } from './components/location.component';
import { LocationRoutingModule } from './location-routing.module';

@NgModule({
  declarations: [LocationComponent],
  imports: [
    LocationRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
  ],
})
export class LocationModule {}

export function loadLocationModuleAsChild() {
  return Promise.resolve(LocationModule);
}
